import { ArrowRightIcon } from 'lucide-react';
import { deliveryDockAlt, images, serviceLinks } from '../data/site';
import { SiteLink } from './SiteLink';
export function ServiceCare() {
  return <section aria-labelledby="service-heading" className="w-full bg-ink" data-id="element-382" data-mp="2j2pynnkm3ytq">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-14" data-id="element-383" data-mp="2j413lqpsncmf">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-384" data-mp="2f0bhd7wld74k">
          <div className="lg:col-span-7" data-id="element-385" data-mp="2szucn04b0nzg">
            <p className="text-[14px] font-bold uppercase text-water" data-id="element-386" data-mp="2syt2cxv445is">Service &amp; Spa Care</p>
            <h2 id="service-heading" className="mt-2 text-h2-mobile font-semibold text-white lg:text-h2-desktop" data-id="element-387" data-mp="2nzoqu0kptvpa">
              Support for Every Season of Spa Ownership
            </h2>
            <p className="mt-4 max-w-2xl text-body text-white/85 sm:text-body-lg" data-id="element-388" data-mp="3br3x24fm4x5t">
              Buying the spa is only the beginning. We help customers with service, repairs,
              maintenance questions, spa care, replacement covers and the everyday details that keep
              ownership enjoyable.
            </p>

            <ul className="mt-6 grid grid-cols-1 gap-x-8 sm:grid-cols-2" data-id="element-389" data-mp="1ganc7ymexgtc">
              {serviceLinks.map(link => <li key={link.label} className="border-b border-white/20" data-id="element-390" data-mp="1l74493wqgfbp">
                  <SiteLink to={link.href} className="flex min-h-[52px] items-center justify-between gap-3 text-[16.5px] font-medium text-white transition-colors duration-150 ease-out hover:text-water" data-id="element-391" data-mp="1q8tdce0eaix5">
                    {link.label}
                    <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-392" data-mp="2407yorhryw7d" />
                  </SiteLink>
                </li>)}
            </ul>
          </div>

          <div className="lg:col-span-5" data-id="element-393" data-mp="2dxw4qdktzq4u">
            <div className="aspect-[3/2] w-full overflow-hidden rounded-card" data-id="element-394" data-mp="2dyxf0fu0w8li">
              <img src={images.deliveryDock} alt={deliveryDockAlt} className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-395" data-mp="2hzzg727i2uq4" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}